class BackInStock extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)

    this.listeners.add(document, 'click', this.handleTrigger)
  }

  async handleTrigger (event) {
    const trigger = event.target.closest(
      '[data-view-similar-external-el="trigger"]',
    )
    if (!trigger) return

    await window.BAO.sectionRenderer
      .fetchSingle('view-similar', trigger.dataset.productUrl)
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)

        const bodyContent = newDOM.querySelector('.shopify-section')
        if (trigger.dataset.size) {
          bodyContent.querySelector('product-recommendations').dataset.size =
            trigger.dataset.size
        }

        this.els.body.element.innerHTML = bodyContent.outerHTML

        const recsEl = this.els.body.element.querySelector(
          'product-recommendations',
        )

        if (recsEl) {
          const openOnReady = () =>
            (window.drawers.activeDrawerKey = 'view-similar')
          recsEl.addEventListener('recommendations:loaded', openOnReady, {
            once: true,
          })
          recsEl.addEventListener('recommendations:empty', openOnReady, {
            once: true,
          })
          recsEl.fetchShopifyRecommendations()
        } else {
          window.drawers.activeDrawerKey = 'view-similar'
        }
      })
      .catch(() => {
        window.drawers.activeDrawerKey = ''
      })
  }
}

if (!customElements.get('view-similar')) {
  customElements.define('view-similar', BackInStock)
}
